import React, { useEffect, useState } from 'react';
import UserFooter from './UserComponent/UserFooter';
import UserHeader from './UserComponent/UserHeader';
import { useFormik } from 'formik';
import { Button, TextField } from '@mui/material';
import { verifyOTPValidationSchema } from './ValidationSchema';
import { resendOTP, verifyOTP } from '../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export const PhoneVerificationOtp = () => {
  const tokan = localStorage.getItem('token');
  const mobile_number = localStorage.getItem('mobile_number');
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const navigate = useNavigate();

  // window.onbeforeunload = () => {
  //   localStorage.clear();
  // }
  const formik = useFormik({
    initialValues: {
      otp: '',
      tokan: localStorage.getItem('token'),
    },
    validationSchema: verifyOTPValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await verifyOTP({ otp: values.otp });

        if (response.status === 200 || response.status === 201) {
          localStorage.setItem('is_verified', response.data.is_verified);
          // window.location.href = '/my_matches';
          navigate("/")
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleResendOtp = async () => {
    try {
      const response = await resendOTP();
      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message);
        const currentTime = Date.now();
        localStorage.setItem('otpResendStartTime', currentTime); // store the start time in localStorage
        setIsResendDisabled(true);
        setTimeRemaining(60); // set timer to 60 seconds
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Error sending OTP, please try again later.");
    }
  };

  useEffect(() => {
    const storedStartTime = localStorage.getItem('otpResendStartTime');

    if (storedStartTime) {
      const currentTime = Date.now();
      const timeElapsed = Math.floor((currentTime - storedStartTime) / 1000); // time in seconds
      const timeLeft = 60 - timeElapsed;

      if (timeLeft > 0) {
        setIsResendDisabled(true);
        setTimeRemaining(timeLeft);
      }
    }

    let timer;
    if (isResendDisabled && timeRemaining > 0) {
      timer = setInterval(() => {
        setTimeRemaining((prev) => prev - 1);
      }, 1000);
    } else if (timeRemaining === 0) {
      setIsResendDisabled(false);
      localStorage.removeItem('otpResendStartTime'); // clear the timer on completion
    }

    return () => clearInterval(timer);
  }, [isResendDisabled, timeRemaining]);

  return (
    <div>
      <UserHeader />
      <section className="siteForm">
        <div className="container">
          <div className="formTitle text-center">
            <h3>Phone Verification</h3>
            <p className="otpTxt mt-4">
              Verification code has been sent to +91-{mobile_number}. Didn't receive the code?
              <span>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleResendOtp();
                  }}
                  style={{ pointerEvents: isResendDisabled ? 'none' : 'auto' }}
                >
                  {isResendDisabled
                    ? `Resend Code (${Math.floor(timeRemaining / 60)}:${(
                      '0' + (timeRemaining % 60)
                    ).slice(-2)})`
                    : 'Resend Code'}
                </a>
              </span>
            </p>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-md-5">
              <form className="mt-4" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Enter Verification Code</label>
                  <TextField
                    fullWidth
                    id="otp"
                    name="otp"
                    placeholder="Enter Verification Code"
                    variant="outlined"
                    value={formik.values.otp}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.otp && Boolean(formik.errors.otp)}
                    helperText={formik.touched.otp && formik.errors.otp}
                  />
                </div>
                <div className="mb-3 d-grid col-12 mx-auto">
                  <Button type="submit" variant="contained" color="primary" className="formBtn">
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
      <UserFooter />
    </div>
  );
};
